import compose from 'recompose/compose';
import withProps from 'recompose/withProps';

export default compose(
  withProps(({ actions }) => ({ actions: actions || [] })),
);
